import { cn } from '../../../shared/lib/cn';
import type { IVerifyStep, TStepState } from '../lib';

const DOT: Record<TStepState, string> = {
  ok: 'bg-faint',
  failed: 'bg-danger',
  skipped: 'bg-suppressed',
  unknown: 'bg-suppressed',
};

const Fact = ({ step }: { step: IVerifyStep }) =>
  step.verbatim ? (
    <p className="mt-tight rounded-control bg-surface-sunken px-flat py-2 font-mono text-meta leading-17 break-all whitespace-pre-wrap text-primary">
      {step.fact}
    </p>
  ) : (
    <p className="mt-tight font-mono text-meta leading-17 break-all text-muted">{step.fact}</p>
  );

export const VerifySteps = ({ steps }: { steps: readonly IVerifyStep[] }) => (
  <div>
    {steps.map((step, index) => (
      <div key={step.key} className="flex gap-3">
        <div className="flex w-4 shrink-0 flex-col items-center">
          <span className={cn('mt-1 size-dot shrink-0 rounded-control', DOT[step.state])} />
          {index < steps.length - 1 && <span className="my-1 w-px flex-1 bg-border" />}
        </div>
        <div className="min-w-0 flex-1 pb-flat-lg">
          <span
            className={cn(
              'text-data font-medium',
              step.state === 'failed' ? 'text-danger' : 'text-primary',
            )}
          >
            {step.title}
          </span>
          <Fact step={step} />
        </div>
      </div>
    ))}
  </div>
);
